<template>
   <div class="print_invoice_contact_details_design_4" id="print_invoice_contact_details_design_4">
      <div class="row">
         <!-- supplier  -->
         <div v-if="supplier" class="w-fit mx-auto">
            <div class="info-holder">
               <span class="label">{{ $t('lang_supplier_name') }}</span> :
               <span>{{ supplier.SpName }}</span>
            </div>
            <div class="info-holder">
               <span class="label">{{ $t('lang_phone') }}</span> : 
               <span>{{ supplier.SpPhone }}</span>
            </div>
            <div class="info-holder">
               <span class="label">{{ $t('lang_address') }}</span> : 
               <span>{{ supplier.SpAddress }}</span>
            </div>

            <div class="info-holder">
               <div class="info-holder info-holder__1">
                  <span class="label">{{ $t('lang_payed') }}</span>: 
                  <span>{{ $filters.setCurrency(payed, currency) }}</span>
               </div>
               <div class="info-holder info-holder__2">
                  <span class="label">{{ $t('lang_remain') }}</span>: 
                  <span>{{ $filters.setCurrency(remain, currency) }}</span>
               </div>
            </div>
         </div>
         
         <!-- customer  -->
         <div v-if="customer" class="w-fit mx-auto">
            <div class="info-holder">
               <span class="label">{{ $t('lang_customer_name') }}</span>:
               <span>{{ customer.CustName }}</span>
            </div>
            <div class="info-holder">
               <span class="label">{{ $t('lang_phone') }}</span>: 
               <span>{{ customer.CustPhone }}</span>
            </div>
            <div class="info-holder">
               <span class="label">{{ $t('lang_address') }}</span>: 
               <span>{{ customer.CustAddress }}</span>
            </div>
            
            <template v-if="invoice_type !== 'installment_invoice'">
               <div class="info-holder">
                  <div class="info-holder info-holder__1">
                     <span class="label">{{ $t('lang_payed') }}</span>: 
                     <span>{{ $filters.setCurrency(payed, currency) }}</span>
                  </div>
                  <div class="info-holder info-holder__2">
                     <span class="label">{{ $t('lang_remain') }}</span>: 
                     <span>{{ $filters.setCurrency(remain, currency) }}</span>
                  </div>
               </div>
            </template>
            <template v-else>
               <div class="info-holder">
                  <div class="info-holder info-holder__1">
                     <span class="label">{{ $t('lang_early_payment') }}</span>: 
                     <span>{{ $filters.setCurrency(installment_head.IHPrepaid, currency) }}</span>
                  </div>
                  <div class="info-holder info-holder__2">
                     <span class="label">{{ $t('lang_remain') }}</span>: 
                     <span>{{ $filters.setCurrency(remain, currency) }}</span>
                  </div>
                  <div class="info-holder info-holder__3">
                     <span class="label">{{ $t('lang_every_month') }}</span>: 
                     <span>{{ $filters.setCurrency(installment_head.IHMonthlyPayAmount, currency) }}</span>
                  </div>
               </div>
            </template>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   props: {
      customer: { type: [Object, Boolean], default: false },
      supplier: { type: [Object, Boolean], default: false },
      payed:  { type: [String, Number], default: 0},
      remain: { type: [String, Number], default: 0},
      installment_head: { type: [Object, Boolean], default: false },
      invoice_type: String,
      currency: String,
   },

   setup(props) {
      if (isEmpty(props.driver)) props.driver    = false;
      if (isEmpty(props.delegate)) props.delegate = false;
   }
}
</script>

<style scoped lang="scss">
@use '@sass/helpers' as *;

.print_invoice_contact_details_design_4 {
   .info-holder {
      display: flex;
      gap: rem(10);
      margin-bottom: rem(5);
      font-size: rem(14);

      > span:nth-child(2) {
         position: relative;

         &::before {
            content: '';
            position: absolute;
            bottom: 0;
            right: 0;
            width: 150px;
            border-bottom: dotted 2px black;
         }
      }

      &__1,
      &__2,
      &__3 {
         > span:nth-child(2) {
            &::before {
               width: 120px;
            }
         }
      }


      &__2, 
      &__3 {
         margin-right: 50px;
      }
   }
}


</style>